module.exports = __webpack_public_path__ + "img/SKMJ_rest1.50002c8a.jpg";